function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.append(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

let hrefColor
let dataSection
class VariantRadiosBundle extends VariantRadios {
  constructor() {
    super();
    this.colors = this.querySelectorAll('fieldset.color-swatches input')
    this.sizes = this.querySelectorAll('fieldset.size-options input')
    dataSection = this.dataset.section
    this.addEventListener('change', this.onChangeHandler)
    super.getVariantData()
    this.existingVariant = location.href.split('variant=')[1]
    this.existingColor = this.variantData.find(v => v.id == this.existingVariant)?.option1.toLowerCase() || null
    this.setAvailability()
    this.displayCoverPictures()
  }

  onChangeHandler() {
    this.setAvailability()
    this.sortVariantPictures()
    this.toggleAddButton()
    this.displaySelected()
  }

  toggleAddButton() {
    return
  }

  displaySelected() {
    const accordionDetails = this.closest('details')
    const displaySelected = accordionDetails.querySelector('.selection-span')

    displaySelected.textContent = accordionDetails.querySelectorAll('variant-radios-bundle:not(.js-none)')[0].currentVariant?.title
  }

  setAvailability() {
    this.firstLoad && (this.colors = this.querySelectorAll('fieldset.color-swatches input:checked'))
    this.colors.forEach(color => {
      let colorAvailability = []

      this.sizes.forEach(size => {
        let currentOption = [color.value, size.value]
        let optionVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return currentOption[index] === option;
          }).includes(false);
        })

        if (!this.firstLoad) {
          colorAvailability.push(optionVariant)
          return
        }

        if (!optionVariant.available) {
          size.nextElementSibling.classList.add('unavailable')
          return
        }
        size.nextElementSibling.classList.remove('unavailable')
      })

      if (!this.firstLoad) {
        if (colorAvailability.every(c => c.available == false)) {
          color.nextElementSibling.classList.add('unavailable-swatch')
          return
        }
        color.nextElementSibling.classList.remove('unavailable-swatch')
      }
    })

    this.firstLoad = true;
  }

  displayCoverPictures () {
    const picturesArray = Array.from(document.querySelectorAll('.product__media-item'));
    picturesArray.forEach(p => {
      if(p.getAttribute('media-alt').includes('cover')) {
        p.style.display = 'block'
        return
      }
      p.style.display = 'none'
    })
  }

  sortVariantPictures() {
    this.selectedColor = this.existingColor || this.querySelectorAll('fieldset.color-swatches input:checked')[0]?.value.toLowerCase()
    this.picturesArray = Array.from(document.querySelectorAll('.product__media-item'));
    this.selectedProductTitle = this.querySelectorAll('fieldset.color-swatches input:checked + label')[0].getAttribute('product-title')
    this.filteredArray = this.picturesArray.filter( x => {
      const altArr = x.getAttribute('media-alt').split(' ');
      const pictureColor = altArr.slice(altArr.indexOf('color') + 1).toString().replace(',', ' ').toLowerCase();
      return pictureColor == this.selectedColor && x.getAttribute('media-alt').split('color')[0].trim() == this.selectedProductTitle.trim()
    })

    if(this.filteredArray.length > 0 ) {
      this.picturesArray.forEach(x => {
        if( this.filteredArray.includes(x) ) {
          x.style.display = 'block'
          return
        }
        x.style.display = 'none'
      })
    }

  };

}

customElements.define('variant-radios-bundle', VariantRadiosBundle)

class VariantRadiosSimple extends VariantRadiosBundle {
  constructor() {
    super()
    this.sortVariantPictures()
  }

  displayCoverPictures() {
    return
  }

  sortVariantPictures() {
    this.selectedColor = this.querySelectorAll('fieldset.color-swatches input:checked')[0].value.toLowerCase()
    this.picturesArray = Array.from(document.querySelectorAll('.product__media-item'));
    this.picturesArray.forEach( x => {
      const altArr = x.getAttribute('media-alt').split(' ');
      const pictureColor = altArr.slice(altArr.indexOf('color') + 1).toString().replace(',', ' ').toLowerCase();
      if (pictureColor == this.selectedColor) {
        x.style.display = 'block'
        return
      }
      x.style.display = 'none'
    })

  };

  displaySelected() {
    return
  }

}

customElements.define('variant-radios-simple', VariantRadiosSimple)
class Bundle extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('bundle-container', Bundle)

class BundleSimple extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('bundle-container-simple', BundleSimple)

let selectedVariants

//Product Bundle option accordion

const selectDropdown = function (ev) {
  const accordionDetails = this.closest('details')
  const displaySelected = accordionDetails.querySelector('.selection-span')

  if (accordionDetails.querySelector('select')) {
    const selectValue = accordionDetails.querySelector('select').value
    const variantRadios = accordionDetails.querySelectorAll('variant-radios-bundle')

    variantRadios.forEach( (v, i) => {
      let product = v.getAttribute('data-product-title')
      v.classList.add('js-none')
      if (selectValue == product) {
        v.classList.remove('js-none')
        v.querySelectorAll('.js-variant-option-color')[0].setAttribute('checked', true)
        v.dispatchEvent(new Event('change'))
      }
    })
    
  }

  displaySelected.textContent = accordionDetails.querySelectorAll('variant-radios-bundle:not(.js-none)')[0].currentVariant?.title

}

const hideVariantPickers = function () {
  const variantRadios = this.querySelectorAll('variant-radios-bundle')
  variantRadios.forEach( (v, i) => {
    if (i == 0) {
      v.classList.remove('js-none');
      return
    }
    v.classList.add('js-none');
    
  })
}

window.addEventListener('load', () => {
  document.querySelectorAll('.accordion__content--bundle').forEach(a => {
    a.hideVariantPickers = hideVariantPickers
    a.hideVariantPickers()
    // a.addEventListener('change', bundleAccordion)
  })
  document.querySelectorAll('.accordion__content--bundle select').forEach(a => {
    a.addEventListener('change', selectDropdown)
  })
})

//Set button availabitlity

const bundleItems = function (ev) {
  const input = ev.currentTarget
  selectedVariants = Array.from(document.querySelectorAll('.variant-picker')).filter(x => !x.classList.contains('js-none')).map(x => x.currentVariant)
  const productForm = document.getElementById(`product-form-${input.dataset?.section || dataSection}`);
  if (!productForm) return;
  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector('[name="add"] > span');
  if (!addButton) return;
  const isBundleAvailable = selectedVariants && selectedVariants.every(v => v !== undefined && v.available == true);

  const text = 'Please select a product option';

  if (!isBundleAvailable) {
    addButton.setAttribute('disabled', 'disabled');
    if (text) addButtonText.textContent = text;
  } else {
    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.addToCart;
  }
}

window.addEventListener('load', () => {
  Array.from(document.querySelectorAll('.variant-picker')).forEach(v => {
    v.addEventListener('change', bundleItems)
    v.dispatchEvent(new Event('change'))
  })
})

//Add all bundle items

const productForm = document.getElementById(`product-form-${dataSection}`);

const addAllItems = function(ev) {
  const submitButton = ev.currentTarget.querySelector('button')
  submitButton.disabled = true
  const event = ev.currentTarget;
  ev.preventDefault()
  //Cart Notification activation:
  const cartNotification = document.querySelector('cart-notification')
  cartNotification.getSectionsToRender = [
      {
        id: 'cart-notification-product',
        selector: `[id="shopify-section-cart-notification-product"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  cartNotification.getSectionInnerHTML = (html, selector = ['.shopify-section']) => {
    let index = Array.isArray(selector) ? selector.length : 1
    let result = []
    const parser = new DOMParser()
    for (let i = 0; i < index; i++ ) {
      let parsedItem = parser.parseFromString(html, 'text/html').querySelector(selector[i]).innerHTML;
      result.push(parsedItem.toString())
    }
    result = result.map(item => `<div class="minicart__item">${item}</div>`).join(' ')
    return result
  }

  cartNotification.renderContents = (parsedState) => {
    cartNotification.getSectionsToRender[0].selector = parsedState.items.map(x => `[id="cart-notification-product-${x.key}"]`)
    cartNotification.cartItemKey = parsedState.items[0].key;
    const cartItemId = parsedState.items[0].variant_id;
    const price = parsedState.items[0].original_price;
    const linePrice = parsedState.items[0].original_line_price;
    const lineAmount = parsedState.items[0].quantity

    cartNotification.getSectionsToRender.forEach((section => {
      if (section.id == 'cart-notification-product') {
        const htmlElement = document.createElement('div')
        htmlElement.classList.add('minicart__line-item')
        htmlElement.setAttribute('d-variant-id', cartItemId)
        htmlElement.innerHTML = cartNotification.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
        
        const priceElement = document.createElement('span')
        priceElement.classList.add('product-option')
        priceElement.classList.add('minicart__line-item-price')
        priceElement.innerHTML = `${lineAmount} X $${(formatMoney(price, "{{ amount }}"))} - <s>$${formatMoney(linePrice, "{{ amount }}")}</s>`

        document.getElementById(section.id).appendChild(htmlElement);
        if (event.classList.contains('bundle-form')) {
          htmlElement.appendChild(priceElement)
        }
        

      } else {
        document.getElementById(section.id).innerHTML =
        cartNotification.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    if (cartNotification.header) cartNotification.header.reveal();
    cartNotification.open();
  }
  const product_data = selectedVariants.map(variant => {
    return {
      quantity: 1,
      id: variant.id,
      selling_plan: variant.selling_plan_allocations.length > 0 ? variant.selling_plan_allocations[0].selling_plan_id : undefined
    }
  })

  const formEl = submitButton.closest('.form');
  if(formEl){
    const propertyEl = formEl.querySelector('.gPreorderProperty');
    if(propertyEl){
      product_data[0].properties = {
         _is_preorder: propertyEl.value
      }
    }
  }

  let lastId = ''
  const variantsToAddToCart = selectedVariants.map(v => v.id)
  const variantsArray = selectedVariants.reduce((acc, curr, i, arr) => {
    let totalQty = 1

    if (curr.id == lastId) {
      let duplicate = arr.find(el => el.id)
      totalQty += 1
      duplicate.qty = totalQty
      return acc

    }

    lastId = curr.id
    curr.qty = totalQty
    acc.push(curr)

    return acc

  }, [])
  
  const data = {
    items: product_data,
    sections: cartNotification.getSectionsToRender.map((section) => section.id)
  }

  const storeName = document.querySelector('input.store-name')?.value || ''
  const bundleProducts = Array.from(document.querySelectorAll('.variant-picker')).filter(x => !x.classList.contains('js-none')).map(x => x.getAttribute('data-product'))
  const bundleData = document.querySelector('.js-bundle-title') ? {
    storeName: storeName,
    selectedVariants: variantsArray,
    bundleProducts: [...new Set(bundleProducts)],
    bundleTitle: document.querySelector('.js-bundle-title').value
  } :
  false

  if (ev.currentTarget.classList.contains('bundle-form')) {
    queueItems(variantsArray, bundleData)
  } else {
    fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin', 
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then((response) => {
      return response.json();
    }).then((json) => {
      console.log('addAllItems', json)
      cartNotification.renderContents(json);
    }).catch((err) => {
      /* uh oh, we have an error. */
      console.error(err)
    });
    if (bundleData != false) {
      //applyDiscountCode(bundleData)
    }
  }

}

async function queueItems(array, bundleData){
  const cartNotification = document.querySelector('cart-notification')
  Shopify.queue = [];
    let quantity = 1 ;
    let newArray = array.map(v => (
      { 
        id: v.id, 
        quantity: v.qty
      }
      ));
    for (let i = 0; i < newArray.length; i++) {
      product = newArray[i]
      Shopify.queue.push({
        variantId: product.id,
        quantity: product.quantity
      });
    }
    document.getElementById('cart-notification-product').innerHTML= ''
    Shopify.moveAlong = async function() {
    // If we still have requests in the queue, let's process the next one.
      if (Shopify.queue.length) {
        let request = Shopify.queue.shift();
        let data = {
          items: [{
            id: request.variantId,
            quantity: request.quantity
          }],
          sections: cartNotification.getSectionsToRender.map((section) => section.id)
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(res){
            cartNotification.renderContents(res);
            Shopify.moveAlong();
            quantity += 1;
          },
          error: function(){
            // if it's not last one Move Along else update the cart number with the current quantity
            if (Shopify.queue.length){
              Shopify.moveAlong()
            } else {
              $('#cart-number').replaceWith('<a href="/cart" id="cart-number">View cart (' + quantity + ')</a>')
            }
          }
        })
      }
      // If the queue is empty, we add 1 to cart
      else {
      quantity += 1;
      displayDiscountsMinicart()
      //applyDiscountOnRedirect(discountData.code)
      //window.location.href = `/discount/${discountData.code}?redirect=/cart`
      }
    };

    Shopify.moveAlong();
};

productForm?.addEventListener('submit', addAllItems)

//Get Discount

const applyDiscountCode = async function (bundle) {

  const bundleData = bundle
  const dashboardUrl = 'http://localhost:3000/api/create-discount'
  const response = await fetch(dashboardUrl, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(bundleData),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
  }).then(res => {
    console.log('res', res)
    return res.json()
  }).then(json => {
    const data = json.body
    const code = JSON.parse(data).discountCode
    // window.location.href = `/discount/${code}?redirect=/cart`
    return {
      data: JSON.parse(data),
      code: code
    }
  }).catch(error => {
    console.log(error)
    alert('There was a problem creating the discount!')
    return error
  })

  return response

}

//Format Shopify money

const formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

//Display discounts to line items in minicart

const displayDiscountsMinicart = async function () {
  const cartData = await fetch('/cart.js').then(res => res.json()).catch(error => { alert('Error fetching cart.'); return error })
  const cartItems = cartData.items
  const cartItemsNodes = document.querySelectorAll('#cart-notification-product .minicart__line-item')

  cartItemsNodes.forEach((el, i) => {
    //const discountedPriceTotal = (cartItems[i].properties._discountData.data.amount / 100 ) * formatMoney(cartItems[i].original_line_price, '{{ amount }}')
    const currentLineItem = cartItems.find(x => x.variant_id == el.getAttribute('d-variant-id')) 
    const discountedPrice = formatMoney(currentLineItem.final_line_price, '{{ amount }}')
    const discountTitle = currentLineItem.discounts[0].title
    const discountElement = document.createElement('div')
    discountElement.style.display = 'inline-block'
    
    discountElement.innerHTML = `
    <strong>$${discountedPrice}
    <svg style="width: 1.2rem" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-{{ settings.accent_icons }}" viewBox="0 0 12 12">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
    </svg>
    ${discountTitle}
    </strong>
    `

    el.querySelector('.minicart__line-item-price').appendChild(discountElement)

  });
}

// window.addEventListener('load', () => {
//   displayDiscounts()
// })

//Apply discount on next redirection

// const applyDiscountOnRedirect = function (code) {
//   if (!localStorage.getItem('discountRedirect')) {
//     const redirect = `/discount/${code}?redirect=/cart`
//     localStorage.setItem('discountRedirect', redirect)
//   }

//   const storedRedirect = localStorage.getItem('discountRedirect')
//   console.log('applyDiscountOnRedirect')

//   //window.location.href = storedRedirect

// }

// window.addEventListener('load', () => {
//   const storedRedirect = localStorage.getItem('discountRedirect')
//   console.log('onLoad', window.location.href)
//   if (window.location.href.includes('cart')) {
//     if (storedRedirect) {
//       console.log(storedRedirect)
//       const redirect = storedRedirect.slice()
//       localStorage.removeItem('discountRedirect')
//       window.location.href = redirect
//     }
//   }
// })